<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-20 11:22:43
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-03 20:55:42
-->

<template>
  <div
    class="boxMian"
    :style="{
      backgroundColor: configInfo.backgroundColour,
    }"
  >
    <div class="page-wrapper" :style="{ backgroundImage: `url('${configInfo.backgroundImg}')` }">
      <div class="kv"><img :src="configInfo.mainKvImg" /></div>
      <div class="model" :style="{ borderColor: configInfo.mainColour }">
        <div
          class="modelTitle"
          :style="{
            backgroundColor: configInfo.mainColour,
            color: configInfo.buttonTextColour,
          }"
        >
          · 给力好友 ·
        </div>

        <div class="modelBg">
          <div class="list">
            <div class="item" v-for="(item, index) in list" :key="index">
              <img class="userImg" :src="item.headImgUrl" />
              <div class="userName">{{ item.nickname }} 已为您助力</div>
              <!-- <div class="num">+{{ item.count }}</div> -->
              <div class="num">+1</div>
              <div class="icon">
                <img class="iconImg" src="https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/vector.png" />
                <span
                  :style="{
                    color: configInfo.mainColour,
                  }"
                  >{{ helpText }}</span
                >
              </div>
            </div>

            <div class="common-nodata" v-if="list.length === 0">
              <div class="zero">
                <div class="zero_top">
                  <img src="http://assets.rurushishi.com/activies/online/dtt-purchase/gift_zero.png" alt />
                </div>
                <div class="zero_bottom">
                  <p>空空如也，还没有好友帮你助力</p>
                  <p>快去邀请好友参加活动领奖品吧～</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <BaseBottom :configInfo="configInfo" />
      <ActBaseBtnHome :bColor="configInfo.buttonBackgroundColour" :textColor="configInfo.buttonTextColour"></ActBaseBtnHome>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},

  data() {
    return {
      configInfo: {}, //配置信息
      list: [],
      back: "#fff",
      helpText: "点亮值",
    };
  },
  watch: {},

  mounted() {
    this.configInfo = this.$configInfo
    if (this.$configInfo.shareSwitch!= 1) {
      this.$wx.hideOptionMenu();
    }
    if (this.configInfo.helpType == 2) {
      this.helpText = this.configInfo.helpText;
    }
    this.init();
  },
  created() {},
  methods: {
    // 页面配置
    async init() {
      let param = this.$apizt.action.getAssistanceUser;
      const { data, result } = await this.$httpzt.requestRestFul(param, {
        actCode: this.$actCode,
        size: 50,
      });
      if (result) {
        console.log(data);
        this.list = data.records;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  // height: 100vh;

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    // overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-top: 40px;
    padding-bottom: 80px;

    .kv {
      width: 295px;
      margin: 8px auto 0;
    }

    .model {
      width: 351px;
      margin: 0px auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 12px;
      height: calc(100vh - 284px);
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border: 5px solid;
      box-sizing: border-box;
      position: relative;
      top: -1px;

      .modelTitle {
        position: absolute;
        margin-top: -20px;
        font-weight: bold;
        color: white;
        padding: 0 20px;
        line-height: 40px;
        height: 40px;
        text-align: center;
        border-radius: 6px;
        display: inline-block;
        z-index: 1;
        font-size: 20px;
      }

      .modelBg {
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 7px;
        padding: 30px 20px 10px;

        .list {
          height: 100%;
          overflow-y: auto;

          .item {
            width: 100%;
            display: flex;
            height: 64px;
            align-items: center;
            justify-content: space-between;
            border-bottom: 0.5px solid rgba(239, 19, 80, 0.2);

            .rank {
              width: 24px;
              height: 24px;
              font-weight: bold;
              font-size: 18px;
              line-height: 24px;
              text-align: center;
              color: #617086;
            }

            .userImg {
              width: 32px;
              height: 32px;
              border-radius: 16px;
            }

            .userName {
              flex: 1;
              padding: 0 16px;
              font-weight: normal;
              font-size: 14px;
              line-height: 24px;
              color: #000000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .num {
              font-weight: bold;
              font-size: 24px;
              line-height: 24px;
              text-align: center;
              color: #262626;
            }

            .icon {
              width: 40px;
              display: flex;
              flex-direction: column;
              align-items: center;
              font-weight: 500;
              font-size: 9px;
              line-height: 10px;
              color: #ef1350;
              margin-left: 10px;

              .iconImg {
                width: 16px;
                height: 16px;
                margin-bottom: 5px;
              }
            }
          }

          .item:last-child {
            border-bottom: none;
          }
        }
        .common-nodata {
          font-size: 14px;
          // font-weight bold;
          text-align: center;
          font-family: PingFang SC;
          margin-top: 20px;
          overflow: hidden;

          .zero {
            display: flex;
            align-items: center;
            flex-direction: column;
            margin-top: 32px;

            .zero_top {
              width: 356px;
              height: 98px;

              img {
                width: 100%;
                height: 100px;
              }
            }

            .zero_bottom {
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 400;
              color: rgba(154, 154, 154, 1);
              line-height: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
